// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__JvJg-","list":"style_list__+ib-c"};